import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { sdk } from "@/api/sdk";
import { POST_LOGIN_REDIRECT_PATH } from "@/features/auth/constants/auth.constants";
import { ConsentGate } from "@/features/legal/modules/consent-gate/consent-gate";
import { APP_LEGAL_CONSENTS, legalConsentStatusOf } from "@/features/legal/utils/legal-consent-gate";
import { m } from "@/paraglide/messages.js";
import { LegalConsentKind, LegalConsentState, legalConsentsToAsk } from "@complete-athlete/enums";

export const Route = createFileRoute("/consent/")({
  staticData: { sitemap: false },
  component: RouteComponent,
  loader: () => ({ crumb: m.legal_gate_eyebrow() }),
  ssr: false,
  validateSearch: z.object({ redirect: z.string().optional(), health: z.boolean().optional() }),
  beforeLoad: async ({ search, location }) => {
    const { data } = await sdk.users.me.$get.send();
    if (!data) {
      throw redirect({ to: "/login", search: { redirect: location.href } });
    }

    const status = await legalConsentStatusOf(data.user.id);
    const asked = status ? legalConsentsToAsk(status, APP_LEGAL_CONSENTS) : [];
    const withdrawn = search.health && status?.[LegalConsentKind.HEALTH_DATA] === LegalConsentState.WITHDRAWN;
    if (asked.length === 0 && !withdrawn) {
      throw redirect({ href: search.redirect ?? POST_LOGIN_REDIRECT_PATH });
    }

    return {
      userId: data.user.id,
      email: data.user.email,
      kinds: asked.length > 0 ? asked : [LegalConsentKind.HEALTH_DATA],
      optional: asked.length === 0,
    };
  },
});

function RouteComponent() {
  const { userId, email, kinds, optional } = Route.useRouteContext();
  const { redirect: redirectTo } = Route.useSearch();
  return <ConsentGate userId={userId} email={email} kinds={kinds} optional={optional} redirectTo={redirectTo} />;
}
